import {DistanceProps} from 'modules/cities/types';
import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import companiesKeys from '../util/companies-keys';

const useCreateNeighborhoodPrice = (companyId: string) => {
  const {create} = useQueryHelpers();

  const onSuccess = (data: DistanceProps) =>
    create(companiesKeys.neighborhoodPrices(companyId), data);

  return useApiMutation<DistanceProps>({
    url: '/neighborhoods/company-prices',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar bairro',
    successTitle: 'Bairro da empresa',
    successMessage: 'Bairro cadastrada com sucesso',
    redirectUrl: `/settings/companies/${companyId}/neighborhood-prices`,
    onSuccess,
  });
};

export default useCreateNeighborhoodPrice;
